// extracted by mini-css-extract-plugin
export default {"logoImg":"nav_logoImg__ZjBN7","noNewRequests":"nav_noNewRequests__9RsCz"};